import { ExclusiveLabel } from "@components/ExclusiveLabel";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, Title3 } from "@components/Typography";
import { convertCentsToDollar, formatCurrency } from "@utils";
import { content } from "./content";
import { useStyles } from "./styles";
import { AccountBalanceCardProps } from "./types";

export const AccountBalanceCard = ({
  accountType,
  balanceInCents,
  accountHolder,
  style,
}: AccountBalanceCardProps) => {
  const styles = useStyles();

  if (!accountType || balanceInCents == null || !accountHolder) return null;

  const amount = formatCurrency(convertCentsToDollar(balanceInCents), true);

  return (
    <div style={{ ...styles.container, ...style }}>
      <div>
        <Title3>{content[accountType]}</Title3>
        <Spacing size={SpacingSizes.XS} />

        <Body style={styles.text}>{amount}</Body>
        <Spacing size={SpacingSizes.XS} />

        <ExclusiveLabel style={styles.exclusive}>{accountHolder}</ExclusiveLabel>
      </div>
    </div>
  );
};
